/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./scopeAccessSelector.vue?vue&type=template&id=60e4b354"
import script from "./scopeAccessSelector.vue?vue&type=script&lang=js"
export * from "./scopeAccessSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports